import script from "./AppMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMenuItem.vue?vue&type=script&setup=true&lang=ts"

import "./AppMenuItem.vue?vue&type=style&index=0&id=0bd8bc19&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bd8bc19"]])

export default __exports__